import React, { useState } from 'react';
import {
  Container, Paper, Typography, TextField, Button, Box, Avatar, Divider
} from '@mui/material';
import { Lock } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { userService } from '../services/userService';
import { toast } from 'react-toastify';
import api from '../services/api';

const Profile = () => {
  const { user, setUser } = useAuth();
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({
    username: user?.username || '',
    email: user?.email || ''
  });
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [showPasswordForm, setShowPasswordForm] = useState(false);

  const handleSubmit = async () => {
    try {
      const updatedUser = await userService.updateUser(user.id, formData);
      setUser({ ...user, ...updatedUser });
      setEditMode(false);
      toast.success('Profil erfolgreich aktualisiert');
    } catch (error) {
      toast.error('Profil konnte nicht aktualisiert werden');
    }
  };

  const handleCancel = () => {
    setFormData({
      username: user?.username || '',
      email: user?.email || ''
    });
    setEditMode(false);
  };

  const handleChangePassword = async () => {
    if (passwordData.newPassword !== passwordData.confirmPassword) {
      toast.error('Neue Passwörter stimmen nicht überein');
      return;
    }
    if (passwordData.newPassword.length < 4) {
      toast.error('Neues Passwort muss mindestens 4 Zeichen lang sein');
      return;
    }
    try {
      await api.put(`/users/${user.id}/password`, {
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword
      });
      toast.success('Passwort erfolgreich geändert');
      setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
      setShowPasswordForm(false);
    } catch (error) {
      toast.error(error.response?.data?.error || 'Passwort konnte nicht geändert werden');
    }
  };

  return (
    <Container maxWidth="md">
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 700, background: 'linear-gradient(135deg, #CC0000 0%, #8B0000 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
        Mein Profil
      </Typography>

      <Paper sx={{ p: { xs: 2, sm: 3 } }}>
        <Box display="flex" flexDirection={{ xs: 'column', sm: 'row' }} alignItems={{ xs: 'center', sm: 'flex-start' }} gap={2} mb={3}>
          <Avatar sx={{ width: { xs: 60, sm: 80 }, height: { xs: 60, sm: 80 }, bgcolor: 'primary.main' }}>
            {user?.username?.charAt(0).toUpperCase()}
          </Avatar>
          <Box>
            <Typography variant="h6">{user?.username}</Typography>
            <Typography color="textSecondary">{user?.role}</Typography>
          </Box>
        </Box>

        <TextField
          fullWidth
          margin="normal"
          label="Name"
          value={formData.username}
          onChange={(e) => setFormData({ ...formData, username: e.target.value })}
          disabled={!editMode}
        />
        <TextField
          fullWidth
          margin="normal"
          label="E-Mail"
          type="email"
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          disabled={!editMode}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Rolle"
          value={user?.role || ''}
          disabled
        />
        <TextField
          fullWidth
          margin="normal"
          label="Mitglied seit"
          value={user?.created_at ? new Date(user.created_at).toLocaleDateString('de-DE') : ''}
          disabled
        />

        <Box mt={3}>
          {!editMode ? (
            <Button variant="contained" onClick={() => setEditMode(true)}>
              Profil bearbeiten
            </Button>
          ) : (
            <>
              <Button variant="contained" sx={{ mr: 1 }} onClick={handleSubmit}>
                Speichern
              </Button>
              <Button variant="outlined" onClick={handleCancel}>
                Abbrechen
              </Button>
            </>
          )}
        </Box>
      </Paper>

      <Paper sx={{ p: 3, mt: 3 }}>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <Lock />
          <Typography variant="h6">Passwort ändern</Typography>
        </Box>

        {!showPasswordForm ? (
          <Button variant="outlined" onClick={() => setShowPasswordForm(true)}>
            Passwort ändern
          </Button>
        ) : (
          <>
            <TextField
              fullWidth
              margin="normal"
              label="Aktuelles Passwort"
              type="password"
              value={passwordData.currentPassword}
              onChange={(e) => setPasswordData({ ...passwordData, currentPassword: e.target.value })}
            />
            <TextField
              fullWidth
              margin="normal"
              label="Neues Passwort"
              type="password"
              value={passwordData.newPassword}
              onChange={(e) => setPasswordData({ ...passwordData, newPassword: e.target.value })}
            />
            <TextField
              fullWidth
              margin="normal"
              label="Neues Passwort bestätigen"
              type="password"
              value={passwordData.confirmPassword}
              onChange={(e) => setPasswordData({ ...passwordData, confirmPassword: e.target.value })}
            />
            <Box mt={2}>
              <Button variant="contained" sx={{ mr: 1 }} onClick={handleChangePassword}>
                Passwort speichern
              </Button>
              <Button variant="outlined" onClick={() => {
                setShowPasswordForm(false);
                setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
              }}>
                Abbrechen
              </Button>
            </Box>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default Profile;
